(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["xtra-cart-validation"]) return;
  try {
    
  (() => {
    if (window.xtraCartGuard) return;
    let pendingCheck;

    // Remove temporary notice data left by the previous country-change UI.
    try { sessionStorage.removeItem('xtra:cart-region-change'); } catch (_) {}
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) window.location.reload();
    });

    function cartUrl() {
      const root = window.Shopify?.routes?.root || '/';
      return new URL(`${root}cart`, window.location.origin);
    }

    function clearError(form) {
      const formId = form?.getAttribute('id');
      if (formId) document.getElementById(`${formId}-cart-error`)?.remove();
    }

    async function hasUnavailableItems() {
      const url = cartUrl();
      url.searchParams.set('section_id', 'xtra-cart-validation');
      const response = await fetch(url, {
        credentials: 'same-origin',
        cache: 'no-store',
        signal: AbortSignal.timeout(5000),
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) throw new Error('Cart availability check unavailable');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      return html.querySelector('[data-xtra-cart-validation]')?.dataset.blocked === 'true';
    }

    window.xtraCartGuard = {
      async check(form) {
        clearError(form);
        try {
          pendingCheck ||= hasUnavailableItems();
          if (await pendingCheck) {
            window.location.assign(cartUrl().href);
            return false;
          }
          return true;
        } catch (error) {
          console.warn('Cart availability check unavailable; Shopify will validate the cart.', error);
          return true;
        } finally {
          pendingCheck = null;
        }
      },

      report(message, form) {
        const formId = form?.getAttribute('id');
        const controls = Array.from(document.querySelectorAll('buy-buttons'))
          .find((element) => element.getAttribute('form') === formId);
        if (!formId || !controls) return false;
        clearError(form);
        const labels = document.querySelector('[data-xtra-cart-validation]')?.dataset;
        const error = document.createElement('div');
        error.id = `${formId}-cart-error`;
        error.className = 'xtra-cart-error';
        error.setAttribute('role', 'alert');
        error.setAttribute('tabindex', '-1');
        const text = document.createElement('p');
        text.textContent = `${labels?.errorPrefix || "We couldn't add this item."} ${String(message || '')}`;
        const link = document.createElement('a');
        link.href = cartUrl().href;
        link.textContent = labels?.reviewCart || 'Review cart';
        link.className = 'link';
        error.append(text, link);
        controls.after(error);
        error.focus({ preventScroll: true });
        error.scrollIntoView({ block: 'nearest', behavior: 'instant' });
        return true;
      }
    };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xtra-why-choose"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('xtra-card-value')) {
    customElements.define('xtra-card-value', class extends HTMLElement {
      connectedCallback() {
        this._context = document.createElement('canvas').getContext('2d');
        const scheduleFit = () => {
          if (this._frame == null) {
            this._frame = requestAnimationFrame(() => {
              this._frame = null;
              this._fit();
            });
          }
        };
        this._resizeObserver = new ResizeObserver(scheduleFit);
        this._resizeObserver.observe(this.parentElement);
        this._textObserver = new MutationObserver(scheduleFit);
        this._textObserver.observe(this, { childList: true, characterData: true, subtree: true });
        document.fonts.ready.then(() => {
          if (this.isConnected) scheduleFit();
        });
        scheduleFit();
      }

      disconnectedCallback() {
        this._resizeObserver?.disconnect();
        this._textObserver?.disconnect();
        cancelAnimationFrame(this._frame);
        this._frame = null;
      }

      _fit() {
        const availableWidth = this.parentElement?.clientWidth - 4;
        if (!this.isConnected || !(availableWidth > 0)) return;
        const value = this.querySelector('.xtraa-card__value');
        if (!value) return;
        const style = getComputedStyle(value);
        const maxSize = parseFloat(style.getPropertyValue('--xtraa-value-fs'));
        if (!(maxSize > 0)) return;
        const text = value.textContent.trim().replace(/\s+/g, ' ');
        this._context.font = `${style.fontStyle} ${style.fontWeight} ${maxSize}px ${style.fontFamily}`;
        const metrics = this._context.measureText(text);
        const letterSpacing = parseFloat(style.letterSpacing) || 0;
        const textWidth = Math.max(metrics.width, metrics.actualBoundingBoxLeft + metrics.actualBoundingBoxRight) + Math.max(0, text.length - 1) * letterSpacing;
        const size = textWidth > 0 ? Math.min(maxSize, maxSize * availableWidth / textWidth) : maxSize;
        const fontSize = `${Math.max(1, Math.floor(size * 100) / 100)}px`;
        if (value.style.fontSize !== fontSize) value.style.fontSize = fontSize;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
